<div class="row px-lg-5 px-2">
	<div class="mt-5">
		<div class="row my-2">
			<form id="systemForm" [formGroup]="systemForm" (ngSubmit)="submitForm()" *ngIf="systemForm">

				<div class="row">
					<span class="theme-main-color fs-4 col">Rapport d'activité</span>
				</div>
				<div class="row my-4">
					<div class="col-12 col-lg">
						<label for="typeExport" class="form-label fw-bold"
							>Type d'export:   </label
						>
						<select
							required
							id="typeExport"
							class="form-select"
							name="typeExport"
							formControlName="typeExport"
							(ngModelChange)="onTypeExportChanged()"
							aria-label="Sélectionner un statut"
							
						>
						<option [value]="TypeExportEnum.TOUT">Tout</option>
						<option [value]="TypeExportEnum.SERVICE">Par service</option>
						<option [value]="TypeExportEnum.SERVICEREGION">Par service et région</option>
						<option [value]="TypeExportEnum.TYPEHANDICAP">Par typologie de handicap</option>
						</select>
					</div>
				</div>
				<div *ngIf="showServiceField" class="row my-4">
					<div class="col-12 col-lg-6">
						<label for="service" class="form-label fw-bold"
							>Service</label
						>
						<select
							id="service"
							class="form-select"
							name="service"
							formControlName="service"
							(change)="onServiceChanged($event)"
							aria-label="Sélectionner un service"
							>
							<option *ngFor="let service of listService" value="{{ service.id }}">
								{{ service.name }}
							</option>
						</select>
					</div>
					<div *ngIf="showRegionField" class="col-12 col-lg-6">
						<label for="region" class="form-label fw-bold"
							>Région</label
						>
						<select
							id="region"
							class="form-select"
							name="region"
							formControlName="region"
							aria-label="Sélectionner une region"
							>
							<option *ngFor="let region of listRegion" value="{{ region.id }}">
								{{ region.name }}
							</option>
						</select>
					</div>
				</div>
				<div *ngIf="showHandicapField" class="row my-4">
					<div class="col-12 col-lg">
						<label for="typeHandicap" class="form-label fw-bold"
							>Typologie de handicap</label
						>
						<select
							id="typeHandicap"
							class="form-select"
							name="typeHandicap"
							formControlName="typeHandicap"
							>
							<option *ngFor="let typeHandicap of listTypeHandicap" value="{{ typeHandicap.id }}">
								{{ typeHandicap.name }}
							</option>
						</select>
					</div>
				</div>
				<div class="row my-4">
					<div class="col-12 col-lg">
						<label for="dateDebutRA" class="form-label fw-bold"
							>Date de début</label
						>
						<input
							autocomplete="off"
							type="text"
							class="form-control"
							bsDatepicker
							id="dateDebutRA"
							name="dateDebutRA"
							formControlName="dateDebutRA"
							[ngClass]="{
								'is-invalid': dateDebutRA.invalid,
								'is-valid': dateDebutRA.dirty && dateDebutRA.valid
							}"
						/>
					</div>
					<div class="col-12 col-lg">
						<label for="dateFinRA" class="form-label fw-bold"
							>Date de fin</label
						>
						<input
							autocomplete="off"
							type="text"
							class="form-control"
							bsDatepicker
							id="dateFinRA"
							name="dateFinRA"
							formControlName="dateFinRA"
							[ngClass]="{
								'is-invalid': dateFinRA.invalid,
								'is-valid': dateFinRA.dirty && dateFinRA.valid
							}"
						/>
					</div>
				</div>
				<div class="row">
					<div class="row mb-5 col-lg-3">
						<div class="d-flex">
							<button
								class="col-lg-12 col-5 my-2 mx-2 btn theme-green-button"
								(click)="generateActivityReport()"
							>
							<span *ngIf="loadingActivityReport" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
							Générer rapport d'activité (.docx)
							</button>
						</div>
					</div>
				</div>


				<div class="row">
					<span class="theme-main-color fs-4 col">Indicateurs</span>
				</div>
				<div class="row my-4">
					<div class="col-12 col-lg">
						<label for="dateDebut" class="form-label fw-bold"
							>Date de début</label
						>
						<input
							autocomplete="off"
							type="text"
							class="form-control"
							bsDatepicker
							id="dateDebut"
							name="dateDebut"
							formControlName="dateDebut"
							[ngClass]="{
								'is-invalid': dateDebut.invalid,
								'is-valid': dateDebut.dirty && dateDebut.valid
							}"
						/>
					</div>
					<div class="col-12 col-lg">
						<label for="dateFin" class="form-label fw-bold"
							>Date de fin</label
						>
						<input
							autocomplete="off"
							type="text"
							class="form-control"
							bsDatepicker
							id="dateFin"
							name="dateFin"
							formControlName="dateFin"
							[ngClass]="{
								'is-invalid': dateFin.invalid,
								'is-valid': dateFin.dirty && dateFin.valid
							}"
						/>
					</div>
				</div>
				<div class="row">
					<div class="row mb-5 col-lg-3">
						<div class="d-flex">
							<button
								class="col-lg-12 col-5 my-2 mx-2 btn theme-green-button"
								(click)="generateReport()"
							>
							<span *ngIf="loadingReport" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
							Générer indicateurs (.xlsx)
							</button>
						</div>
					</div>
				</div>
				

				<div class="row">
					<span class="theme-main-color fs-4 col">Gestion des tâches planifiées</span>
				</div>

				<div class="row">
				<div class="row mb-5 col-lg-3">
					<div class="d-flex">
						<button
							class="col-lg-12 col-5 my-2 mx-2 btn theme-green-button"
							(click)="updateBdcTrackHours()"
						>
							<i class="fs-5 bi bi-plus-lg" aria-hidden="true"></i> Mettre à jour le suivi des heures
						</button>
					</div>
				</div>

				<div class="mb-5 col-lg-3">
					<div class="d-flex">
						<button
							class="col-lg-12 col-5 my-2 mx-2 btn theme-green-button"
							(click)="generateAndAddToGedSynthesisBdc()"
						>
							<i class="fs-5 bi bi-plus-lg" aria-hidden="true"></i> Générer les dernières synthèses de suivi des BDC pour chaque service
						</button>
					</div>
				</div>

				<div class="mb-5 col-lg-3">
					<div class="d-flex">
						<button
							class="col-lg-12 col-5 my-2 mx-2 btn theme-green-button"
							(click)="updateServer()"
						>
							<i class="fs-5 bi bi-plus-lg" aria-hidden="true"></i> Mettre à jour le serveur (cotraitant 04/07)
						</button>
					</div>
				</div>
				</div>

				<div class="row">
					<span class="theme-main-color fs-4 col">Configuration SMTP</span>
				</div>
				<div class="row my-4">
					<div class="col-12 col-lg-6">
						<label for="smtpHost" class="form-label theme-main-color fw-bold">Serveur</label>
						<input autocomplete="off" type="text" class="form-control" id="smtpHost" name="smtpHost"
							formControlName="smtpHost" />
					</div>
					<div class="col-12 col-lg-6">
						<label for="smtpPswd" class="form-label theme-main-color fw-bold">Mot de passe</label>
						<input autocomplete="off" type="text" class="form-control" id="smtpPswd" name="smtpPswd"
							formControlName="smtpPswd" />
					</div>
				</div>
				<div class="row my-4">
					<div class="col-12 col-lg-6">
						<label for="smtpUserName" class="form-label theme-main-color fw-bold">Nom d'utilisateur</label>
						<input autocomplete="off" type="text" class="form-control" id="smtpUserName" name="smtpUserName"
							formControlName="smtpUserName" />
					</div>
					<div class="col-12 col-lg-6">
						<label for="smtpPort" class="form-label theme-main-color fw-bold">Port</label>
						<input autocomplete="off" type="text" class="form-control" id="smtpPort" name="smtpPort"
							formControlName="smtpPort" />
					</div>
				</div>


				<div class="row">
					<span class="theme-main-color fs-4 col">Configuration de la GED</span>
				</div>
				<div class="row my-4">
					<div class="col-12 col-lg-6">
						<label for="gedHost" class="form-label theme-main-color fw-bold">Serveur</label>
						<input autocomplete="off" type="text" class="form-control" id="gedHost" name="gedHost"
							formControlName="gedHost" />
					</div>
					<div class="col-12 col-lg-6">
						<label for="gedPswd" class="form-label theme-main-color fw-bold">Mot de passe</label>
						<input autocomplete="off" type="text" class="form-control" id="gedPswd" name="gedPswd"
							formControlName="gedPswd" />
					</div>
				</div>

				<div class="row my-4">
					<div class="col-12 col-lg-6">
						<label for="gedUsername" class="form-label theme-main-color fw-bold">Nom d'utilisateur</label>
						<input autocomplete="off" type="text" class="form-control" id="gedUsername" name="gedUsername"
							formControlName="gedUsername" />
					</div>
					<div class="col-12 col-lg-6">
						<label for="gedPort" class="form-label theme-main-color fw-bold">Port</label>
						<input autocomplete="off" type="text" class="form-control" id="gedPort" name="gedPort"
							formControlName="gedPort" />
					</div>
				</div>

				<div class="row my-5">
					<div class="d-flex justify-content-end">
						<button [disabled]="!systemForm.valid || isValidateButtonClicked.value" class="btn theme-green-button" form="systemForm" type="submit">
							<i class="bi bi-save-fill px-1" aria-hidden="true"></i>Sauvegarder
						</button>
					</div>
				</div>
			</form>
		</div>
	</div>
</div>